/* @flow */

import React from "react";

import { FormattedMessage } from "react-intl";
import { Label } from "react-bootstrap";

type Props = {
    value: number;
};

export const FlashSaleCounter = ({ value }: Props) => {
    const chars = value.toString().split("");
    return (
        <span>
            <Label className="label-promotion label-rectangular">
                <FormattedMessage id="EX_PROMOTION_FLASH" />
            </Label>
            <span className="label-group label-counter">
                {chars.map((char, i) => (
                    <Label key={i} className="label-promotion label-rectangular">
                        {char}
                    </Label>
                ))}
                <span className="text-promotion">
                    {" "}
                    <FormattedMessage id="EX_FLASH_SALES_COUNTER_IN_STOCK" />
                </span>
            </span>
        </span>
    );
};
